// Device breakpoints. Matches designSpace/styles/_designVariables.scss.
export const WEBSITE_BUILDER_MOBILE_START_BREAKPOINT = 320;
export const WEBSITE_BUILDER_MOBILE_END_BREAKPOINT = 767;
export const WEBSITE_BUILDER_TABLET_START_BREAKPOINT = 768;
export const WEBSITE_BUILDER_TABLET_END_BREAKPOINT = 1023;
export const WEBSITE_BUILDER_DESKTOP_START_BREAKPOINT = 1024;

// Design space boundary widths. Matches designSpace/styles/_designVariables.scss.
export const WEBSITE_BUILDER_DESIGN_SPACE_BOUNDARY_MOBILE_WIDTH = WEBSITE_BUILDER_MOBILE_START_BREAKPOINT;
export const WEBSITE_BUILDER_DESIGN_SPACE_BOUNDARY_TABLET_WIDTH = WEBSITE_BUILDER_TABLET_START_BREAKPOINT;
export const WEBSITE_BUILDER_DESIGN_SPACE_BOUNDARY_DESKTOP_WIDTH = 1000;

export type TWebsiteBuilderDevice = "desktop" | "tablet" | "mobile";